import React from 'react';

/** Paste clipboard as plain text only (avoids rich HTML background styles). */
export function pastePlainTextOnly(e: React.ClipboardEvent<HTMLElement>): void {
  e.preventDefault();
  const text = e.clipboardData.getData('text/plain');
  document.execCommand('insertText', false, text);
}
